
import { StocktakingListId__get_unwrap, StocktakingId__get_unwrap } from "../Shared/Shared.js";
import Shipment_Check from "../../public/assets/icons/Shipment_Check.svg";
import Shipment_Time from "../../public/assets/icons/Shipment_Time.svg";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { unwrap, some } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { empty, map, singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { canRecordStocktakingResults, usePermissions } from "../UserPermissions.js";
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";
import swr from "swr";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { StocktakingCountingTaskDto_$reflection } from "../Shared/Stocktaking.js";
import { list_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../ErrorHandling.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";

export const countingTasksKey = "/api/stocktakings/counting-tasks";

const refreshEventName = "stocktaking-counting-tasks-refresh";

export function refreshCountingTasks() {
    window.dispatchEvent(new Event(refreshEventName));
}

export function countingRoute(stocktakingId, stocktakingListId) {
    return ["stocktaking", StocktakingId__get_unwrap(stocktakingId), "lists", StocktakingListId__get_unwrap(stocktakingListId), "count"];
}

function toNotificationElement(translateInterpreted, task) {
    let arg_1, arg_3;
    let patternInput;
    const matchValue = task.StocktakingListState;
    switch (matchValue.tag) {
        case 1:
        case 2: {
            patternInput = ["stocktaking.counting.task_text_open", Shipment_Check()];
            break;
        }
        default:
            patternInput = ["stocktaking.counting.task_text_start", Shipment_Time()];
    }
    const Key = StocktakingListId__get_unwrap(task.StocktakingListId);
    const Title = (arg_1 = {
        name: task.StocktakingName,
    }, translateInterpreted("stocktaking.counting.task_title", arg_1));
    return {
        DisplayName: (arg_3 = {
            counted: task.CountedPositions,
            date: toString(toLocalTime(task.EndDate), "dd.MM.yyyy"),
            list: task.StocktakingListName,
            total: task.TotalPositions,
        }, translateInterpreted(patternInput[0], arg_3)),
        Icon: some(patternInput[1]),
        Key: Key,
        OnClick: (_arg) => {
            RouterModule_nav(ofArray(countingRoute(task.StocktakingId, task.StocktakingListId)), 1, 1);
        },
        Title: unwrap(Title),
    };
}

export function useCountingTasks(accountSettings) {
    let tasks;
    const patternInput = useTranslation();
    const permissions = usePermissions();
    const enabled = (isFeatureEnabled(new Feature(4, [])) && accountSettings.InventoryEnabled) && canRecordStocktakingResults(permissions);
    const swrResponse = swr(enabled ? countingTasksKey : defaultOf(), (url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(StocktakingCountingTaskDto_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), {
        refreshInterval: 60000,
    });
    useEffectWithDeps(() => {
        const onRefresh = (_arg_1) => {
            swrResponse.mutate();
        };
        window.addEventListener(refreshEventName, onRefresh);
        return createDisposable(() => {
            window.removeEventListener(refreshEventName, onRefresh);
        });
    }, []);
    const matchValue = swrResponse.data;
    let matchResult, tasks_1;
    if (matchValue != null) {
        if ((tasks = matchValue, enabled)) {
            matchResult = 0;
            tasks_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return map((task) => toNotificationElement((arg, arg_1) => (patternInput[1].t(arg, arg_1)), task), tasks_1);
        default:
            return empty();
    }
}

